import * as Yup from "yup"

export const validationSchema = Yup.object({
  idTokenType: Yup.object().required('Kindly select an id token'),
  startTime: Yup.date().required('Kindly select a start date and time'),
  endTime: Yup.date().required('Kindly select an end date and time'),
  station: Yup.object().required("Kindly select a station")
})